import { ShieldCheck, Flag, UserCheck } from 'lucide-react';

const safetyFeatures = [
  {
    icon: Flag,
    title: 'One-Click Reporting',
    description: 'Easily report inappropriate behavior with a single click'
  },
  {
    icon: UserCheck,
    title: '18+ Age Verification',
    description: 'All users must verify they are 18 or older to use the platform'
  },
  {
    icon: ShieldCheck,
    title: 'Active Moderation',
    description: 'Our team works to keep the community safe and welcoming'
  }
];

export function SafetySection() {
  return (
    <section className="py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#11B981]/10 rounded-full mb-4">
            <ShieldCheck className="w-8 h-8 text-[#11B981]" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Your Safety Comes First
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            We've built multiple layers of protection to ensure a safe and respectful environment
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {safetyFeatures.map((feature) => (
            <div
              key={feature.title}
              className="flex items-start gap-4 p-4 rounded-lg bg-[#1A2332]/50 w-full md:w-[calc(50%-12px)]"
            >
              <div className="flex-shrink-0 w-10 h-10 bg-[#11B981]/10 rounded-lg flex items-center justify-center">
                <feature.icon className="w-5 h-5 text-[#11B981]" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-1">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-sm">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
